import React from 'react';
import { ArchiveBoxXMarkIcon } from "@heroicons/react/24/outline";

const EmptyContent = () => {
    return (
        <div className="flex flex-col items-center justify-center h-full py-12 px-4 text-center">
            <ArchiveBoxXMarkIcon className="h-24 w-24 text-gray-800 mb-6" />
            <h3 className="text-3xl font-semibold text-gray-800 mb-2">No Content Available</h3>
            <p className="text-black max-w-md">
                It looks like there’s nothing to show here right now. Please check back later or try a different section.
            </p>
        </div>
    );
};

export default EmptyContent;
